<script>
	import Controlador from "../controlador.svelte";
	import {beforeUpdate} from "svelte";
	let c;
	export let empleado;
	let id;
	let nombre,apellido,sobrenombre;
	let cargo;
	let telefono,instagram;
	let togle = false;
	let actual = "historial";
	beforeUpdate(()=>{
		if (empleado){
			id = empleado._id;
			nombre = empleado.nombre;
			apellido = empleado.apellido;
			sobrenombre = empleado.sobrenombre;
			telefono = empleado.celular;
			instagram = empleado.instagram;
            cargo = empleado.cargo;
        }
	})
	function historial(){
		togle = !togle;
	}
	function eliminar(){
		//eliminar empleado
		c.eliminarEmpleado(empleado);
	}
	function whatsapp(number){
		window.open("https://api.whatsapp.com/send?phone="+number);
	}

</script>
<Controlador bind:this={c} />
<div class="w-full bg-white m-2 flex flex-col items-center rounded shadow">
	<div class="w-full flex items-center">
		<div class="w-full flex flex-col mx-2">
			<span class="text-xs font-bold">Sobrenombre:</span>
			<p class="text-xs md:text-sm">{sobrenombre}</p>
		</div>
		<div class="flex flex-col mx-2" >
			<span class="text-xs font-bold">Cargo:</span>
			<p class="text-xs md:text-sm">{cargo}</p>
		</div>
		<div class="flex items-center">
                <button on:click={()=>{whatsapp(telefono)}} class="bg-red-500 text-white flex items-center justify-center m-2 p-2 rounded shadow cursor-pointer hover:bg-red-300 hover:shadow-xl">
                        <i class="ri-whatsapp-line" />
                </button>
                
			<a href={`#/empleados/${id}`} class="bg-red-500 text-white flex items-center justify-center m-2 p-2 rounded shadow cursor-pointer hover:bg-red-300 hover:shadow-2">
				<i class="ri-edit-line" />
			</a>
			<button on:click={eliminar} class="bg-red-500 text-white flex items-center justify-center m-2 p-2 rounded shadow cursor-pointer hover:bg-red-300 hover:shadow-2">
				<i class="ri-delete-bin-5-line" />
		</div>
	</div>
	{#if togle}
		<div class="bg-green-100 w-full p-2 mb-2 flex flex-col">
			<span class="text-xs font-bold">Historial</span>
			<div>
				datos
			</div>
		</div>
	{/if}
</div>
